'use client';

import { useEffect, useState } from 'react';
import HeroSection from './HeroSection';
import DifferentiationSection from './DifferentiationSection';
import ComparisonSection from './ComparisonSection';
import ExecutiveTeamSection from './ExecutiveTeamSection';
import LimitationsSection from './LimitationsSection';
import CompetitivePositioningSection from './CompetitivePositioningSection';
import CTASection from './CTASection';

const WhyDannyClansInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <HeroSection />
        <DifferentiationSection />
        <ComparisonSection />
        <ExecutiveTeamSection />
        <LimitationsSection />
        <CompetitivePositioningSection />
        <CTASection />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
      <DifferentiationSection />
      <ComparisonSection />
      <ExecutiveTeamSection />
      <LimitationsSection />
      <CompetitivePositioningSection />
      <CTASection />
    </div>
  );
};

export default WhyDannyClansInteractive;